import { useEffect, useState } from 'react';

export default function useProcessing() {
	const [isLoading, setIsLoading] = useState(false);
	//isProcessing is array of keys, key represents each function that is processing something
	const [isProcessing, setIsProcessing] = useState<string[]>([]);

	//Function to add to processing
	const handleProcessing = (key: string, isProcessing: boolean) => {
		if (isProcessing) {
			//add key to processing array
			setIsProcessing(prevKeys => [...prevKeys, key]);
		} else {
			//remove key from processing array
			setIsProcessing(prevKeys => prevKeys.filter(item => item !== key));
		}
	};

	//Function for handling loading, for all async processes, loading has to be false all is finished
	useEffect(() => {
		//is there is some key in processing isLoading has to be true, if not is false
		setIsLoading(isProcessing.length > 0);
	}, [isProcessing]);

	//USE: if you need to show loading until multiple functions are complete you will call handleProcessing, using second parameter true/false you trigger state of each function. IsLoading remains true until all functions call handleProcessing with second parameter false

	return {
		isLoading,
		handleProcessing,
	};
}
